/* Lecteur vidéo au clic. Aucune lecture automatique, aucune boucle.

   Le `controls` est écrit dans le HTML puis retiré ici : sans JavaScript la
   vidéo reste lisible avec les contrôles natifs, et avec JavaScript on affiche
   d'abord la vignette et le gros bouton, sans la barre en doublon. Les
   contrôles reviennent dès que la lecture démarre.

   Écouteurs délégués au document : l'éditeur de thème réinjecte une section
   sans recharger la page, un écouteur posé sur l'élément serait perdu. */
(function () {
  if (window.__lecteurVideo) return;   // le fichier peut être inclus 2 fois sur une page
  window.__lecteurVideo = true;

  function preparer() {
    document.querySelectorAll('.lv__video[controls]').forEach(function (v) {
      if (v.closest('.lv').classList.contains('is-playing')) return;
      v.removeAttribute('controls');
    });
  }

  function lancer(lv) {
    var v = lv.querySelector('video');
    if (!v) return;
    lv.classList.add('is-playing');
    v.setAttribute('controls', '');
    var p = v.play();
    // Si le navigateur refuse — rare, la lecture vient d'un clic — on remontre
    // le bouton plutôt que de laisser une vignette morte.
    if (p && p.catch) p.catch(function () { lv.classList.remove('is-playing'); });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.lv__play');
    if (b) lancer(b.closest('.lv'));
  });

  // 'play' et 'ended' ne remontent pas : capture obligatoire. Couvre aussi une
  // lecture lancée depuis les contrôles natifs plutôt que depuis notre bouton.
  document.addEventListener('play', function (e) {
    var lv = e.target.closest && e.target.closest('.lv');
    if (lv) { lv.classList.add('is-playing'); e.target.setAttribute('controls', ''); }
  }, true);

  // À la fin, on rend le bouton : un clic relance depuis le début.
  document.addEventListener('ended', function (e) {
    var lv = e.target.closest && e.target.closest('.lv');
    if (lv) lv.classList.remove('is-playing');
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preparer);
  } else {
    preparer();
  }
  document.addEventListener('shopify:section:load', preparer);
})();
